<template>
  <td :class="cellClass">
    <slot v-if="!isMobile || hideTitle"></slot>
    <template v-else>
      <div class="v-data-table__mobile-row__header">{{ headItem.text || '' }}</div>
      <div class="v-data-table__mobile-row__cell">
        <slot></slot>
      </div>
    </template>
  </td>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    headItem: {
      type: Object,
      default: () => {},
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cellClass() {
      let obj = {
        'v-data-table__mobile-row': this.isMobile,
      }
      if (this.headItem.align) {
        obj[`text-${this.headItem.align}`] = true
      } else {
        obj['text-start'] = true
      }

      return obj
    },
  },
  methods: {},
}
</script>
